//import 'vite/modulepreload-polyfill'
import './main.sass'

import img1 from './images/1.svg';
import img2 from './images/2.svg';
import img3 from './images/3.svg';
import img4 from './images/4.svg';
import burger from './images/burger.svg';

document.documentElement.style.setProperty('--burger-icon', `url(${burger})`);


(() => console.log('💙 TamToMy dev was here 👀'))();


(function () {
    const uspItems = document.querySelectorAll("#usp_hp .usp-item");
    const newSrcs = [img1, img2, img3, img4];

    uspItems.forEach((item, index) => {
        const imageWrapper = item.querySelector(".usp-image");
        const linkInImage = imageWrapper?.querySelector("a");
        const img = imageWrapper?.querySelector("img");

        if (linkInImage && img) {
            const imgClone = img.cloneNode(true);
            linkInImage.replaceWith(imgClone);
        }

        const newImg = imageWrapper?.querySelector("img");
        if (newImg && newSrcs[index]) {
            newImg.src = newSrcs[index];
        }

        const textWrapper = item.querySelector(".usp-text");
        const linkInText = textWrapper?.querySelector("a");

        if (linkInText) {
            const span = document.createElement("h5");
            span.innerHTML = linkInText.innerHTML;
            linkInText.replaceWith(span);
        }
    });
})();

//-------------------------------------------

(function () {
    const observer = new MutationObserver(() => {
        const footer = document.querySelector("#footer");
        if (!footer) return;

        const contactWrapper = footer.querySelector(".contact-wrapper");
        const contactDiv = footer.querySelector(".contact-div");
        const lastItem = footer.querySelector(".contact-item.last");

        if (!contactWrapper || !contactDiv) return;

        contactWrapper.querySelectorAll("img").forEach((img) => img.remove());

        contactDiv.innerHTML = `
      <p><small>E-mail</small><br><a href="mailto:objednavky@sothys.cz">objednavky@sothys.cz</a></p>
      <p><small>Telefon</small><br><a href="tel:736607275">+420 736 607 275</a></p>
    `;

        if (lastItem) {
            lastItem.remove();
        }

        observer.disconnect();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
})();


//---------------------------


(function () {
    const observer = new MutationObserver(() => {
        const loginLink = document.querySelector('a[href="/prihlaseni/"]');
        if (loginLink) {
            loginLink.setAttribute("href", "/login/");
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
})();


//---------------------------

(function () {
    const form = document.getElementById("se-webform-4");
    if (!form) return;

    const body = form.querySelector(".se-body");
    const submit = form.querySelector(".se-submit");
    const header = form.querySelector(".se-header");

    if (body && submit) {
        const customBlock = document.createElement("div");
        customBlock.classList.add("custom-form-info");
        customBlock.innerHTML = `
          <span>
            Všechny položky označené * jsou povinné. Odesláním souhlasíte se <a href="/podminky-ochrany-osobnich-udaju/" style="text-decoration: underline">zpracováním osobních údajů.</a>
          </span>
        `;

        submit.parentNode.insertBefore(customBlock, submit);
    }
    if (header) {
        const description = document.createElement("div");
        description.classList.add("form-description");
        description.innerHTML = `
          <p>
            V případě zájmu o spolupráci se značkou Sothys nám prosím zanechte své údaje. Budeme vás kontaktovat.
          </p>
        `;
        header.appendChild(description);
    }
})();

//------------------------

(function () {
    function appendLineToPaginationWrapper() {
        document.querySelectorAll('.pagination-wrapper').forEach(wrapper => {
            const hasPagination = wrapper.querySelector('.pagination')
            const hasLoader = wrapper.querySelector('.pagination-loader')

            if (hasPagination && hasLoader && !wrapper.querySelector('.pagination_line')) {
                const line = document.createElement('div')
                line.className = 'pagination_line'
                wrapper.appendChild(line)
            }
        })
    }

    appendLineToPaginationWrapper()

    const observer = new MutationObserver(() => {
        appendLineToPaginationWrapper()
    })

    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
})();


//-----------------------


(function () {
    const interval = setInterval(() => {
        const iframe = document.querySelector('.lightwidget-widget');
        if (!iframe || !iframe.parentNode) return;

        const previousSibling = iframe.previousElementSibling;

        if (
            previousSibling &&
            previousSibling.classList.contains('lightwidget-title')
        ) {
            clearInterval(interval);
            return;
        }

        const heading = document.createElement('h2');
        heading.textContent = 'Sledujte nás na Instagramu';
        heading.className = 'lightwidget-title';

        iframe.parentNode.insertBefore(heading, iframe);
        clearInterval(interval);
    }, 100);
})();


//------------------------

(function () {
    const interval = setInterval(() => {
        const errorContainer = document.querySelector('.empty-content-404');
        if (!errorContainer) return;

        const p = errorContainer.querySelector('p');
        if (p && p.textContent.includes('Chyba bude nejspíše na našem přijímači')) {
            p.innerHTML = `
        Chyba bude nejspíše na našem přijímači, proto se zkuste vrátit na
        <a href="/">úvodní stránku</a>,
        nebo kontaktujte naši
        <a href="/kontakty">zákaznickou podporu</a>.
      `;
            clearInterval(interval);
        }
    }, 100);
})();

//----------------------

(function () {
    const btn = document.querySelector('.next-step-finish');
    if (btn) {
        btn.textContent = 'OBJEDNAT S POVINNOSTÍ PLATBY';
    }
})();

//------------------

(function removeAllListenersFromCheckoutSidebar() {
    const oldEl = document.querySelector('#checkoutSidebar');
    if (!oldEl) return;

    const newEl = oldEl.cloneNode(true);

    oldEl.parentNode.replaceChild(newEl, oldEl);
})();

//------------------------

(function () {
    const form = document.querySelector('#register-form');
    if (!form) return;

    const body = form.querySelector(".submit-wrapper");

    const alreadyExists = form.querySelector(".custom-form-info");
    if (body && !alreadyExists) {
        const customBlock = document.createElement("div");
        customBlock.classList.add("custom-form-info");
        customBlock.innerHTML = `
          <span>
            Všechny položky označené * jsou povinné. Odesláním souhlasíte se <a href="/podminky-ochrany-osobnich-udaju/" style="text-decoration: underline">zpracováním osobních údajů.</a>
          </span>
        `;

        body.parentNode.insertBefore(customBlock, body);
    }
})();

//---------------------------

(function () {
    const forms = document.querySelectorAll('#formForgottenPassword, .user-action-login, #formLogin');
    if (!forms.length) return;

    forms.forEach(form => {
        const body = form.querySelector(".login-wrapper");

        const alreadyExists = form.querySelector(".custom-form-info");

        if (body && !alreadyExists) {
            const customBlock = document.createElement("div");
            customBlock.classList.add("custom-form-info");
            customBlock.innerHTML = `
              <span style="color: white">
                Všechny položky označené * jsou povinné. Odesláním souhlasíte se 
                <a href="/podminky-ochrany-osobnich-udaju/" style="text-decoration: underline; color: white">
                  zpracováním osobních údajů.
                </a>
              </span>
            `;

            body.parentNode.insertBefore(customBlock, body);
        }
    });
})();


(function () {
    const observer = new MutationObserver(() => {
        const widget = document.querySelector('.lightwidget-widget');
        const footer = document.querySelector('#footer');
        if (widget && footer && footer.parentNode) {
            footer.parentNode.insertBefore(widget, footer);
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();


const helper = document.querySelector('.menu-helper')
const menu = document.querySelector('.menu-level-1')

helper.addEventListener('click', function (e) {
    e.stopPropagation()
    menu.classList.toggle('is-active')
})

document.addEventListener('click', function (e) {
    if (!menu.contains(e.target) && !helper.contains(e.target)) {
        menu.classList.remove('is-active')
    }
});

document.querySelectorAll('.menu-level-1 li').forEach(li => {
    li.classList.remove('exp', 'splitted')
});


(function () {
    const form = document.querySelector('#formForgottenPassword');
    if (form) {
        const label = form.querySelector('label');
        if (label) {
            label.textContent = 'Váš email *';
        }
    }
})();


(function () {
    const items = document.querySelectorAll('.menu-level-1 li');

    items.forEach(li => {
        if (li.parentElement && li.parentElement.classList.contains('LiDiv')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'LiDiv';

        li.parentNode.insertBefore(wrapper, li);
        wrapper.appendChild(li);
    });
})();

(function () {
    const wrappers = document.querySelectorAll('.menu-level-1 .LiDiv');

    wrappers.forEach(wrapper => {
        const hasSubmenu = wrapper.querySelector('ul.menu-level-2');
        if (!hasSubmenu) return;

        let timeoutId;

        wrapper.addEventListener('mouseover', () => {
            if (window.innerWidth > 768) {
                clearTimeout(timeoutId);
                wrapper.classList.add('showing');
            }
        });

        wrapper.addEventListener('mouseout', (e) => {
            if (window.innerWidth > 768 && !wrapper.contains(e.relatedTarget)) {
                timeoutId = setTimeout(() => {
                    wrapper.classList.remove('showing');
                }, 200);
            }
        });
    });
})();

(function () {
    const firstBannerSections = document.querySelectorAll('#first_banner');

    if (firstBannerSections.length >= 1) {
        const firstSectionLinks = firstBannerSections[0].querySelectorAll('a');
        if (firstSectionLinks.length >= 2) {
            firstSectionLinks[1].href = 'https://sothys.tamtomy.cz/pro-profesionaly/';
            firstSectionLinks[1].target = '_blank';
        }
    }

    if (firstBannerSections.length >= 2) {
        firstBannerSections[1].remove();
    }
})();

(function () {
    const contactBox = document.querySelector('.contact-box');
    if (!contactBox) return;

    const name = contactBox.querySelector('[data-testid="contactboxName"]');
    if (name) name.textContent = 'Zákaznická podpora';

    const img = contactBox.querySelector('img');
    if (img) {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 640 512');
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svg.innerHTML = `
      <path d="M544 248l0 3.3 69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5L296 64c-37.1 0-67.6 28-71.6 64l-.4 0 0 120c0 22.1 17.9 40 40 40s40-17.9 40-40l0-72c0 0 0-.1 0-.1l0-15.9 16 0 136 0c0 0 0 0 .1 0l7.9 0c44.2 0 80 35.8 80 80l0 8zM336 192l0 56c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-118.6c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1l160 0c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16l2.7 0c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8l0-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"/>
    `;
        img.replaceWith(svg);
    }
})();

(function () {
    const footer = document.querySelector('#footer');
    const link = footer?.querySelector('a[href="/pro_profesionaly/"]');

    if (link) {
        link.href = 'https://sothys.tamtomy.cz/pro-profesionaly/';
        link.target = '_blank';
        link.rel = 'noopener';
    }
})();
document.querySelectorAll('p').forEach(p => {
    if (p.offsetWidth === 0 || p.clientWidth === 0 || p.getBoundingClientRect().width === 0) {
        p.style.display = 'none';
    }
});

document.querySelectorAll('.basic-description').forEach(container => {
    const flexes = Array.from(container.querySelectorAll('.dm-flex'));

    // ty co mají třídu one, two nebo three
    const marked = flexes.filter(el =>
        el.classList.contains('one') ||
        el.classList.contains('two') ||
        el.classList.contains('three')
    );

    // ty co ji nemají
    const others = flexes.filter(el => !marked.includes(el));

    // První případ: přesně 2 a jeden z nich je "marked"
    if (flexes.length === 2 && marked.length === 1 && others.length === 1) {
        const target = others[0];
        target.style.display = 'flex';
        target.style.width = '100%';
        target.style.justifyContent = 'space-between';
        target.style.gap = '4rem';
        return;
    }

    // Druhý případ: více než 2 a některý je "marked"
    if (flexes.length > 2 && marked.length >= 1 && others.length >= 1) {
        others.forEach(flex => {
            flex.style.width = '45%';
        });
        return;
    }

    // Třetí případ: přesně 2 a žádný není "marked"
    if (flexes.length === 2 && marked.length === 0) {
        flexes.forEach(flex => {
            flex.style.width = '45%';

        });
    }
});


(function () {
    document.querySelectorAll('.basic-description').forEach(container => {
        container.querySelectorAll('p').forEach(el => {
            const html = el.innerHTML.trim();
            const text = el.textContent.trim();

            if (
                text === '' ||
                html === '&nbsp;' ||
                html === '&#160;' ||
                html === '<br>' ||
                html === '<br/>' ||
                html === '<br />'
            ) {
                el.remove();
            }
        });
    });
})();



